'use strict';

// Contains a list of possible BE status values for wholesale export
module.exports = {
  success: 'completed',
  pending: 'sent_to_job_api',
  failed: 'failed',
  noResults: 'noResults',
};
